import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme/theme.service';
import { SharedService } from './core/services/shared/shared.service';
// import { NotificationsService } from './core/services/notifications/notifications.service';
import { SHARED } from './shared/shared';
import { Toast } from 'primeng/toast';
import { SwUpdate } from '@angular/service-worker';

// https://www.learnbydo.ing/courses/angular/basics/60-http-client/http-resource
@Component({
  selector: 'app-root',
  imports: [SHARED, Toast],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Ejazaaty';
  notifications: any[] = [];
  user: any;
  sessionId: string = '';

  constructor(
    private themeService: ThemeService,
    private sharedService: SharedService,
    updates: SwUpdate,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
    // private notificationsService: NotificationsService
  ) {
    this.themeService.loadUserPreference();
    updates.versionUpdates.subscribe((e: any) => {
      if (e.type === 'VERSION_READY' && isPlatformBrowser(this.platformId)) {
        this.document.location.reload();
      }
    });
  }
  ngOnInit() {
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.getRegistrations().then(regs => {
    //     regs.forEach(reg => {
    //       // Fix for old cached SW that causes freeze
    //       if (!reg.active && !reg.installing) {
    //         console.log('🧹 Removing broken SW:', reg.scope);
    //         reg.unregister();
    //       }
    //     });
    //   });
    // }
    // Don't block rendering - execute after rendering is complete
    // Use requestIdleCallback if available, otherwise setTimeout
    // if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    //   requestIdleCallback(
    //     () => {
    //       this.initializeApp();
    //     },
    //     { timeout: 500 }
    //   );
    // } else {
    //   setTimeout(() => {
    //     this.initializeApp();
    //   }, 0);
    // }
  }

  // private initializeApp() {
  //   try {
  //     this.user = this.sharedService.getUserInfo();

  //     // Subscribe to session updates (non-blocking)
  //     this.notificationsService.session$.subscribe(sessionId => {
  //       this.sessionId = sessionId;
  //     });

  //     // Initialize push notifications if user is logged in (non-blocking)
  //     if (this.user && this.user.id) {
  //       // Don't await - let it run in background to not block rendering
  //       this.initializeNotifications().catch(error => {
  //         console.error('Failed to initialize notifications:', error);
  //       });
  //     }

  //     // Load user notifications (non-blocking) - delay to not block initial render
  //     if (this.user && this.user.id) {
  //       setTimeout(() => {
  //         this.loadNotifications();
  //       }, 1000); // Load after initial render
  //     }
  //   } catch (error) {
  //     console.error('Error in app component initialization:', error);
  //     // Don't block app from loading even if there's an error
  //   }
  // }

  ngOnDestroy() {
    // Cleanup is handled by the notifications service
  }

  // private async initializeNotifications() {
  //   console.log('Initializing notifications');
  //   try {
  //     const subscribed =
  //       await this.notificationsService.subscribeToNotifications();
  //     console.log('Subscribed:', subscribed);
  //     if (subscribed) {
  //       console.log('Push notifications initialized successfully');
  //     } else {
  //       console.log(
  //         'Push notifications not available or user denied permission'
  //       );
  //     }
  //   } catch (error) {
  //     console.error('Failed to initialize notifications:', error);
  //   }
  // }

  // private loadNotifications() {
  //   if (this.user && this.user.id) {
  //     // Add timeout to prevent hanging - use setTimeout to make it truly non-blocking
  //     setTimeout(() => {
  //       this.notificationsService.getNotifications(this.user.id).subscribe({
  //         next: notifications => {
  //           this.notifications = notifications;
  //         },
  //         error: error => {
  //           console.error('Failed to load notifications:', error);
  //           // Don't block rendering if notifications fail to load
  //         },
  //       });
  //     }, 0); // Execute in next event loop to not block initialization
  //   }
  // }

  // // Method to manually subscribe to notifications (can be called from UI)
  // async subscribeToNotifications() {
  //   await this.initializeNotifications();
  // }

  // // Method to mark notification as read
  // markAsRead(notificationId: number) {
  //   this.notificationsService.markAsRead(notificationId).subscribe({
  //     next: () => {
  //       // Update local notifications array
  //       const notification = this.notifications.find(
  //         n => n.id === notificationId
  //       );
  //       if (notification) {
  //         notification.is_read = true;
  //       }
  //     },
  //     error: error => {
  //       console.error('Failed to mark notification as read:', error);
  //     },
  //   });
  // }
}
